module.exports = __webpack_public_path__ + "static/media/pluseIconWhite.e8ebbf1d.svg";